import { useSnackbar} from "@sagecentral/core-ui";
import { FileOrLink, IAttachmentTypeListItem } from "models/attachments";
import useTaskAttachmentAddExisting from "hooks/tasks/useTaskAttachmentAddExisting";
import { useTaskAttachmentDupCheck, useTaskContext } from "hooks/tasks";
import { ExistingAttachmentForm } from "components/attachments";

type TaskExistingAttachmentProps = {    
    taskId: number | undefined;
    types: IAttachmentTypeListItem[] | null;
    onClose: () => void;
    onRefresh: () => void;
}

const TaskExistingAttachment = (props: TaskExistingAttachmentProps) => {    
    const { taskId, types, onClose, onRefresh } = props;
    const { displaySnackbar } = useSnackbar();
    const taskContext = useTaskContext();
    const { task, template, updateTaskOverview } = taskContext;
    
    //--------------------------------------- HOOKS CALLS ---------------------------------------//    
    const [ dupCheck, isDupCheckLoading ] = useTaskAttachmentDupCheck(taskId!);
    const [ save, saving ] = useTaskAttachmentAddExisting(taskId!);
    
    const handleSave = async (ids: number[], filenames: string, typeId: number, fileOrLink: FileOrLink) => {
        const [ exists, files ] = await dupCheck(typeId, fileOrLink, filenames);
        if (exists) {
            displaySnackbar('error', `The following file(s) already exist: ${files.join(', ')}`);
            return;
        }

        const result = await save(ids) as string[];
        if (task && result) {
            const reqs = task!.requirements;
            reqs?.map(r => {
                if (r.tabKey === 'attachments' && result.find(v => v === r.key)) {
                    r.isDone = true;
                }
            })
            updateTaskOverview({ ...task, requirements: reqs });
            displaySnackbar("success", "Success! Attachment added");

            onRefresh();
            onClose();
        }
    };
    //--------------------------------------- HOOKS CALLS ---------------------------------------//

    //--------------------------------------- HANDLERS ---------------------------------------//
   
    //--------------------------------------- HANDLERS ---------------------------------------//

    return (
        <ExistingAttachmentForm 
            types={types}
            onSave={handleSave}
            onClose={onClose}
            saving={saving || isDupCheckLoading}
        />
    )
};

export default TaskExistingAttachment;